import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';

const LoginButton: React.FC = () => {
  const { instance } = useMsal();

  const handleLogin = async () => {
    try {
      // Clear any cached tokens before login to ensure fresh authentication
      console.log('🧹 Clearing cached tokens before login...');
      localStorage.removeItem('msal.token.keys');
      localStorage.removeItem('msal.token.values');
      sessionStorage.clear();
      
      // Debug: Log current MSAL configuration before login
      console.log('🔧 MSAL Config at login:', {
        clientId: instance.getConfiguration().auth.clientId,
        authority: instance.getConfiguration().auth.authority,
        redirectUri: instance.getConfiguration().auth.redirectUri,
      });
      console.log('🔧 Login request scopes:', loginRequest.scopes);
      console.log('🚪 Starting login process with redirect flow...');
      
      // Use redirect flow (more reliable for MSAL with CSP policies)
      await instance.loginRedirect(loginRequest);
      
      // Note: Code after loginRedirect won't execute as the page will redirect to Microsoft login
      
    } catch (e: any) {
      // Detailed error logging
      console.error('🚨 Login failed - Full error details:', {
        name: e.name,
        message: e.message,
        errorCode: e.errorCode,
        errorMessage: e.errorMessage,
        subError: e.subError,
        correlationId: e.correlationId,
        stack: e.stack?.substring(0, 500), // First 500 chars only
        rawError: e
      });
      
      // Handle specific error types securely
      if (e.name === 'BrowserAuthError' || e.name === 'InteractionRequiredAuthError') {
        console.log('User interaction required or browser error occurred');
        alert('Login failed. Please check your internet connection and try again.');
      }
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'var(--dark-primary, #0f0f23)',
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{
        backgroundColor: 'var(--dark-secondary, #1a1a2e)',
        padding: '3rem',
        borderRadius: '1rem',
        textAlign: 'center',
        maxWidth: '400px',
        width: '90%',
        border: '1px solid var(--border-color, #2a2a3e)'
      }}>
        {/* Logo */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.75rem',
          marginBottom: '2rem'
        }}>
          <div style={{
            width: '2.5rem',
            height: '2.5rem',
            backgroundColor: 'var(--accent-color, #6366f1)',
            borderRadius: '0.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.25rem',
            fontWeight: 'bold',
            color: 'white'
          }}>
            L
          </div>
          <span style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: 'var(--text-primary, #ffffff)',
          }}>
            Lex AI
          </span>
        </div>

        <h1 style={{
          fontSize: '1.75rem',
          fontWeight: '600',
          color: 'var(--text-primary, #ffffff)',
          marginBottom: '0.75rem',
          margin: 0
        }}>
          Welcome to Lex AI
        </h1>
        
        <p style={{
          color: 'var(--text-secondary, #a1a1aa)',
          marginBottom: '2rem',
          fontSize: '1rem',
          lineHeight: '1.5'
        }}>
          Your intelligent assistant for Prosper Finance. Sign in with your Microsoft account to access your dashboard, emails, tasks, and more.
        </p>

        <button
          onClick={handleLogin}
          style={{
            width: '100%',
            padding: '1rem 1.5rem',
            backgroundColor: '#0078d4',
            color: 'white',
            border: 'none',
            borderRadius: '0.5rem',
            fontSize: '1rem',
            fontWeight: '500',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            transition: 'background-color 0.2s'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = '#106ebe';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = '#0078d4';
          }}
        >
          <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
            <path d="M8.5 0H0v8.5h8.5V0zm0 9.5H0V18h8.5v-8.5zm1 0V18H18v-8.5h-8.5zm0-1H18V0h-8.5v8.5z"/>
          </svg>
          Sign in with Microsoft
        </button>

        <p style={{
          fontSize: '0.75rem',
          color: 'var(--text-tertiary, #71717a)',
          marginTop: '1.5rem',
          lineHeight: '1.4'
        }}>
          By signing in, you agree to access your Microsoft 365 data including emails, calendar, and tasks for AI-powered assistance.
        </p>
      </div>
    </div>
  );
};

export default LoginButton;
